'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  color: ', ';\n  font-size: ', ';\n  margin: 10px 0 15px;\n\n  svg {\n    color: ', ';\n    margin-right: 5px;\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    width: 100%;\n  }\n'], ['\n  display: inline-block;\n  color: ', ';\n  font-size: ', ';\n  margin: 10px 0 15px;\n\n  svg {\n    color: ', ';\n    margin-right: 5px;\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    width: 100%;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CTAAlert = _styledComponents2.default.span(_templateObject, _config.colors.red, (0, _rem2.default)('14px', _config.typography.baseFontSize), _config.colors.yellow);

CTAAlert.displayName = 'CTA Alert';

exports.default = CTAAlert;